import React, {useState} from 'react'
import {Button, Divider, Grid, Header, Icon, Search, Segment,Input,Form, Confirm} from 'semantic-ui-react'
import styles from './order-summary.module.css'
import PropTypes from "prop-types";

function OrderSummary(props){

    OrderSummary.propTypes = {
        prev: PropTypes.func,
        next: PropTypes.func,
        saveOrderPayment: PropTypes.func,
        selectedCard: PropTypes.object,
    };


    const [open, setOpen] = useState(false);
    const [result, setResult] = useState("");
    const [recordName, setRecordName] = useState("");
    const [serviceMessage, setServiceMessage] = useState('');
    const [messageOpen, setMessageOpen] = useState(false);

    const handleConfirm = (e) => {
        setResult('confirmed');
        setOpen(false );
        props.saveOrderPayment(e,recordName);
    }

    const handleCancel = () => {
        setResult('cancelled');
        setOpen(false);
    }

    const show = (e) => {
        e.preventDefault();
        if (!recordName || recordName === "" || recordName.trim().length == 0) {
            setServiceMessage("Lütfen kayıt adı giriniz.")
            setMessageOpen(true);
        } else {
            setOpen(true);
        }
    }

    const handleRecordNameChange=(e)=> {
        if (messageOpen){
            setMessageOpen(false);
        }
        setRecordName(e.target.value)
    }


    return (
        <React.Fragment>
            <Segment placeholder>
            <Grid columns={2} stackable textAlign='center'>
                <Divider vertical></Divider>

                <Grid.Row verticalAlign='middle'>
                    <Grid.Column>
                        <Header icon>
                            <Icon name='address card' />
                            Abone Bilgileri
                        </Header>
                        <div className={styles.paymentSummary}>
                            <table frame="shides" rules="rows">
                                <tbody>
                                <tr className={styles.tr}>
                                    <td className={styles.label}>Kurum</td>
                                    <td className={styles.value}>{props.invoice.corpName}</td>
                                </tr>
                                <tr className={styles.tr}>
                                    <td className={styles.label}>Fatura No</td>
                                    <td className={styles.value}>{props.invoice.subscriberNo}</td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </Grid.Column>
                    <Grid.Column>
                        <Header icon>
                            <Icon name='credit card outline' />
                            Ödeme Yöntemi
                        </Header>

                        <div className={styles.paymentSummary}>
                            <table frame="shides" rules="rows">
                                <tbody>
                                <tr className={styles.tr}>
                                    <td className={styles.label}>Kart Adı</td>
                                    <td className={styles.value}>{props.selectedCard.alias}</td>
                                </tr>
                                <tr className={styles.tr}>
                                    <td className={styles.label}>Kart Numarası</td>
                                    <td className={styles.value}>{props.selectedCard.paymentCardNumber}</td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </Grid.Column>
                </Grid.Row>
            </Grid>
            </Segment>
            <Form>
                {messageOpen == true ? (
                    <h5 style={{color:'red'}}>{serviceMessage}</h5>
                ) : (<h1></h1>)
                }
                <h3>
                <Form.Input
                    control={Input}
                    label='Kayıt Adı'
                    value={recordName}
                    name="recordName"
                    onChange={handleRecordNameChange}
                />
                </h3>
            </Form>
            <br/>
            <Button onClick={props.prev}>Geri</Button>
            <Button onClick={show}>Tamamla</Button>
            <Button onClick={props.close} floated='right' >Vazgeç</Button>
            <Confirm
                content="Paycell cüzdanınızda kayıtlı kartınızdan fatura ödeme talimatı verilecektir. Onaylıyor musunuz?"
                open={open}
                cancelButton='Vazgeç'
                confirmButton="Onaylıyorum"
                onCancel={handleCancel}
                onConfirm={handleConfirm}
            />
        </React.Fragment>
    )
}

export default OrderSummary;